<app-error-page title="Error 404" actionText="Go to Home page" (onAction)="navigateToStartPage()">
    <p>Whoops! We couldn't find what you're looking for.</p>
    <p class="mb-30">Please try again to enter URL address or</p>
</app-error-page>
